import React from 'react';
import cm from 'classnames';

import { ReactComponent as Ico } from 'assets/nav-pane/settings.svg';
import styles from './_editor-config.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const ConfigIco = ({ className, ...rest }: Props) => {
  return (
    <div {...rest} className={cm(styles.ConfigIco, className)}>
      <Ico />
    </div>
  );
};
